module.exports = __webpack_public_path__ + "img/person.303041a5.jpg";